export default {
  title: process.env.VUE_APP_TITLE,
  version: process.env.VUE_APP_VERSION,
  pageTitle: '',
  showSidebar: true,
};
